export default "__VITE_ASSET__Byw1eOyu__"